import { render } from "./EventTicketModal.vue?vue&type=template&id=6145ba52&scoped=true"
import script from "./EventTicketModal.vue?vue&type=script&lang=js"
export * from "./EventTicketModal.vue?vue&type=script&lang=js"

import "./EventTicketModal.vue?vue&type=style&index=0&id=6145ba52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6145ba52"]])

export default __exports__